<template>
  <div class="layout" v-if="routesWithLayout.includes(route.name)">
    <div class="layout-header" v-if="!isWx && !isDD && title">
      <my-header :title="title" :pagePath="pagePath"></my-header>
    </div>
    <div class="layout-wrap">
      <router-view />
    </div>
    <div
      :class="{
        'layout-bottom': true,
        'layout-bottom-nowhite': routesWithLayoutBottomNoWhite.includes(
          route.name,
        ),
      }"
    ></div>
  </div>
  <div
    :class="{ routerWrap: true, showHeader: !isWx && !isDD && title }"
    v-else
  >
    <my-header
      v-if="!isWx && !isDD && title"
      :title="title"
      :pagePath="pagePath"
    ></my-header>
    <router-view />
    <van-tabbar
      v-model="active"
      v-if="$route.meta.showTab && !isApp && !isMiniprogram"
    >
      <van-tabbar-item replace to="/meeting">
        <span>研修</span>
        <template #icon="props">
          <img
            :src="
              props.active
                ? 'https://susuanqiniu.knowbox.cn/fe/h5-tarc/meeting-tab-active.png'
                : 'https://susuanqiniu.knowbox.cn/fe/h5-tarc/meeting-tab.png'
            "
          />
        </template>
      </van-tabbar-item>
      <van-tabbar-item replace to="/personal-center">
        <span>我的</span>
        <template #icon="props">
          <img
            :src="
              props.active
                ? 'https://susuanqiniu.knowbox.cn/fe/h5-tarc/my-tab-active.png'
                : 'https://susuanqiniu.knowbox.cn/fe/h5-tarc/my-tab.png'
            "
          />
        </template>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script setup>
import { storage } from "@/utils";
import { showToast } from "vant";
import MyHeader from "./components/Header/MyHeader.vue";
const state = reactive({
  isWx: window.navigator.userAgent.toLowerCase().match("micromessenger"),
  isDD: /DingTalk\/\d/i.test(window.navigator.userAgent),
  isApp: "",
  active: 0,
});
const route = useRoute();
const routesWithLayout = computed(() => []);

// 底部导航是白色的情况
const routesWithLayoutBottomNoWhite = computed(() => []);

// 是否小程序webview环境
const isMiniprogram = computed(
  () => window.__wxjs_environment === "miniprogram",
);

watch(
  () => route.path,
  (val) => {
    nextTick(() => {
      if (route.path === "/personal-center") {
        state.active = 1;
      } else {
        state.active = 0;
      }
    });
  },
  { immediate: true },
);
onMounted(async () => {
  function updateOnline() {
    if (!navigator.onLine) {
      showToast("请检查网络～");
    }
  }

  window.addEventListener("online", updateOnline);
  window.addEventListener("offline", updateOnline);
  if (route.name === "AppProtocol") {
    // protocol兼容Andorid webview禁用storage缓存情况，localStorage、sessionStorage使用报错
    state.isApp = route?.query?.source || "";
    return;
  }
  state.isApp = storage.get("sourceDevice");
  // let defaultTitle = state.isApp ? "研修" : "小盒老师";
  // if (state.isApp && (route.meta.title === "小盒老师" || !route.meta.title)) {
  //   document.title = "研修";
  // } else {
  //   document.title = route.meta?.title || defaultTitle;
  // }
});
const title = computed(() => {
  if (["AppProtocol"].includes(route.name)) {
    // 协议详情 等不需要显示header
    return "";
  }
  // 浏览器、app内环境设置title
  if (!state.isWx && !state.isDD) {
    let name = "";
    let defaultTitle = state.isApp ? "研修" : "小盒老师";
    if (state.isApp && route.meta.title === "小盒老师") {
      name = "研修";
    } else {
      if (route.path !== "/") {
        name = route.meta?.title || defaultTitle;
      }
    }
    return name || "";
  }
  return "";
});
const pagePath = computed(() => {
  if (state.isApp) {
    return route.path;
  }
  return "";
});
const { isWx, isDD, isApp, active } = toRefs(state);
</script>

<style lang="less">
html {
  height: 100%;
}
body {
  // overflow: hidden;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior-y: none;
  height: 100%;
}
#app {
  font-family: BlinkMacSystemFont, -apple-system, Avenir, Helvetica, Arial,
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  max-width: 375px;
  margin: auto;
  overflow: hidden;
  height: 100%;
}
.page-container {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow-y: auto;
  overflow-x: hidden;
  font-size: 16px;
  user-select: none;
  -webkit-overflow-scrolling: touch;
  &::-webkit-scrollbar {
    display: none;
  }
}
.routerWrap {
  height: 100%;
}
.showHeader {
  padding-top: calc(constant(safe-area-inset-top) + 44px);
  padding-top: calc(env(safe-area-inset-top) + 44px);
  box-sizing: border-box;
  overflow: hidden;
}
.layout {
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: stretch;
  height: 100vh;
  .layout-header {
    height: calc(constant(safe-area-inset-top) + 44px);
    height: calc(env(safe-area-inset-top) + 44px);
  }
  .layout-wrap {
    flex: 1;
    overflow: auto;
  }
  .layout-bottom {
    height: calc(constant(safe-area-inset-bottom));
    height: calc(env(safe-area-inset-bottom));
  }
  .layout-bottom-nowhite {
    background: #f7f8fa;
  }
}
</style>
